// extracted by mini-css-extract-plugin
export default {"container":"pF-z","header":"qF-z","details":"rF-z","link":"sF-z"};